import { qaAttribute } from '../constants/qaAttributes';

export default (qaLabel?: string) =>
  qaLabel
    ? {
        [qaAttribute]: qaLabel,
      }
    : {};
